module.exports = __webpack_public_path__ + "static/media/ico_ticket1.b58ada62.svg";